'use strict';

exports.__esModule = true;
exports.default = createStore;

var _redux = require('redux');

var _clientMiddleware = require('./middleware/clientMiddleware');

var _reactRouterRedux = require('react-router-redux');

function createStore(history, client, data) {
  // Sync dispatched route actions to the history
  var reduxRouterMiddleware = (0, _reactRouterRedux.syncHistory)(history);

  var middleware = [(0, _clientMiddleware.clientMiddleware)(client), reduxRouterMiddleware];
  var loggerware = [(0, _clientMiddleware.logger)(), reduxRouterMiddleware];
  // const validateware = [validateActivity(client), reduxRouterMiddleware];
  var loggerwareDev = [(0, _clientMiddleware.loggerDev)(), reduxRouterMiddleware];
  var crashReporterware = [(0, _clientMiddleware.crashReporter)(), reduxRouterMiddleware];
  var crashReporterwareLog = [(0, _clientMiddleware.crashReporterLog)(), reduxRouterMiddleware];

  var finalCreateStore = void 0;
  if (__DEVELOPMENT__ && __CLIENT__ && __DEVTOOLS__) {
    var _require = require('redux-devtools'),
        persistState = _require.persistState;

    var DevTools = require('../containers/DevTools/DevTools');
    finalCreateStore = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, loggerwareDev),
    // applyMiddleware(...validateware),
    _redux.applyMiddleware.apply(undefined, crashReporterwareLog), _redux.applyMiddleware.apply(undefined, middleware), window.devToolsExtension ? window.devToolsExtension() : DevTools.instrument(), persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/)))(_redux.createStore);
  } else if (__MOCK__ && __CLIENT__ && __DEVTOOLS__) {
    var _require2 = require('redux-devtools'),
        _persistState = _require2.persistState;

    var _DevTools = require('../containers/DevTools/DevTools');
    finalCreateStore = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, loggerwareDev),
    // applyMiddleware(...validateware),
    _redux.applyMiddleware.apply(undefined, crashReporterwareLog), _redux.applyMiddleware.apply(undefined, middleware), window.devToolsExtension ? window.devToolsExtension() : _DevTools.instrument(), _persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/)))(_redux.createStore);
  } else {
    finalCreateStore = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, loggerware),
    // applyMiddleware(...validateware),
    _redux.applyMiddleware.apply(undefined, crashReporterware), _redux.applyMiddleware.apply(undefined, middleware))(_redux.createStore);
  }

  var reducer = require('./modules/reducer');
  var store = finalCreateStore(reducer, data);

  reduxRouterMiddleware.listenForReplays(store);

  if (__DEVELOPMENT__ && module.hot) {
    module.hot.accept('./modules/reducer', function () {
      store.replaceReducer(require('./modules/reducer'));
    });
  }

  if (__MOCK__ && module.hot) {
    module.hot.accept('./modules/reducer', function () {
      store.replaceReducer(require('./modules/reducer'));
    });
  }

  return store;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/create.js
// module id = 1404
// module chunks = 0